export const HOTJAR_BADGE_ID = 20
export const LIGHTHOUSE_PID = 42039686
export const LOGGED_PLAN_ID = 2
